import { StyleSheet } from 'react-native';

import { ActionSheet, Button, Text, YStack } from '@fhs/ui';
import {
  CHECKOUT_DELIVERY_FEES_MODAL,
  CLOSE_DELIVERY_FEE_MODAL,
} from '@fhs-legacy/frontend/src/utils/test-ids';

function DeliveryFeesInfoModal({ onClose }: { onClose: () => void }) {
  return (
    <ActionSheet isVisible onClose={onClose} headerTitle="Delivery Fees">
      <YStack testID={CHECKOUT_DELIVERY_FEES_MODAL} style={modalStyles.container}>
        <YStack style={modalStyles.section}>
          <Text.Heading type="four">Base Fee</Text.Heading>
          <Text.Paragraph size="md">
            This is the standard delivery fee charged for all delivery orders.
          </Text.Paragraph>
        </YStack>

        <YStack style={modalStyles.section}>
          <Text.Heading type="four">Long Distance Fee</Text.Heading>
          <Text.Paragraph size="md">
            An additional fee applied when your delivery location is beyond our standard delivery
            radius.
          </Text.Paragraph>
        </YStack>

        <YStack style={modalStyles.section}>
          <Text.Heading type="four">Geographical Fee</Text.Heading>
          <Text.Paragraph size="md">
            Additional fees may apply based on your specific delivery location and local
            regulations.
          </Text.Paragraph>
        </YStack>

        <Button type="solid" size="lg" onPress={onClose} testID={CLOSE_DELIVERY_FEE_MODAL}>
          <Button.Text>Ok</Button.Text>
        </Button>
      </YStack>
    </ActionSheet>
  );
}

export default DeliveryFeesInfoModal;

const modalStyles = StyleSheet.create({
  container: {
    gap: 24,
    padding: 24,
    paddingTop: 32,
  },
  section: {
    gap: 8,
  },
});
